import {
  DetalhamentosExtraType,
  ProducoesNormaisType,
} from "../../types/extratoRepasse.types";
import { DemonstrativoFinanceiroState } from "../../types/state.types";
import { StoreAction } from "../reduxTypes";
import * as actions from "./actions";

const initialState: DemonstrativoFinanceiroState = {
  requisitado: false,
  filtros: {
    contrato: "",
    dataPagamento: "",
    sintetico: false,
  },
  listaContratos: [],
  listaDatasPagamento: [],
  dadosExtratoSintetico: undefined,
  dadosDemonstrativo: undefined,
  dadosPlantoesNormais: undefined,
  dadosPlantoesNormaisResumo: undefined,
  dadosPlantoesSobreaviso: undefined,
  dadosPlantoesSobreavisoResumo: undefined,
  dadosProducoesNormais: undefined,
  dadosTotalProducoesNormais: undefined,
  dadosTotalProducoesSobreaviso: undefined,
  dadosProducoesSobreaviso: undefined,
  dadosRelatorioProdutividade: undefined,
  dadosProcedimentos: undefined,
  dadosDetalhamentosExtra: undefined,
  loading: false,
};

const reducer = (
  state: DemonstrativoFinanceiroState = initialState,
  action: StoreAction
): DemonstrativoFinanceiroState => {
  switch (action.type) {
    case actions.DEM_FIN_ATUAL__INICIALIZA_ESTADO:
      return {
        ...state,
        requisitado: true,
      };

    case actions.DEM_FIN_ATUAL__SET_CONTRATOS:
      return {
        ...state,
        listaContratos: [...action.payload],
      };

    case actions.DEM_FIN_ATUAL__SET_DATAS_PAGAMENTO:
      return {
        ...state,
        listaDatasPagamento: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_REL_SINTETICO:
      return {
        ...state,
        dadosExtratoSintetico: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_DADOS_EXTRATO:
      return {
        ...state,
        dadosDemonstrativo: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_PROCEDIMENTOS:
      return {
        ...state,
        dadosProcedimentos: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_REL_PRODUTIVIDADE:
      return {
        ...state,
        dadosRelatorioProdutividade: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_PLANTOES_NORMAIS:
      return {
        ...state,
        dadosPlantoesNormais: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_PLANTOES_NORMAIS_RESUMO:
      return {
        ...state,
        dadosPlantoesNormaisResumo: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_PLANTOES_SOBREAVISO:
      return {
        ...state,
        dadosPlantoesSobreaviso: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_PLANTOES_SOBREAVISO_RESUMO:
      return {
        ...state,
        dadosPlantoesSobreavisoResumo: action.payload,
      };

    case actions.DEM_FIN_ATUAL__SET_PRODUCOES_NORMAIS:
      if (action.payload) {
        const dadosProducoesNormais = action.payload as ProducoesNormaisType[];
        const dadosTotalProducoesNormais = dadosProducoesNormais.reduce(
          (ant, prod) => {
            return {
              TurnoDiurno: {
                Valor: ant.TurnoDiurno.Valor + prod.TurnoDiurno.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoDiurno.HorasTrabalhadas +
                  prod.TurnoDiurno.HorasTrabalhadas,
              },
              TurnoNoturno: {
                Valor: ant.TurnoNoturno.Valor + prod.TurnoNoturno.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoNoturno.HorasTrabalhadas +
                  prod.TurnoNoturno.HorasTrabalhadas,
              },
              TurnoDiurnoFDS: {
                Valor:
                  ant.TurnoDiurnoFDS.Valor + prod.TurnoDiurnoFDS.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoDiurnoFDS.HorasTrabalhadas +
                  prod.TurnoDiurnoFDS.HorasTrabalhadas,
              },
              TurnoNoturnoFDS: {
                Valor:
                  ant.TurnoNoturnoFDS.Valor + prod.TurnoNoturnoFDS.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoNoturnoFDS.HorasTrabalhadas +
                  prod.TurnoNoturnoFDS.HorasTrabalhadas,
              },
            };
          },
          {
            TurnoDiurno: { Valor: 0, HorasTrabalhadas: 0 },
            TurnoNoturno: { Valor: 0, HorasTrabalhadas: 0 },
            TurnoDiurnoFDS: { Valor: 0, HorasTrabalhadas: 0 },
            TurnoNoturnoFDS: { Valor: 0, HorasTrabalhadas: 0 },
          }
        );
        return {
          ...state,
          dadosProducoesNormais,
          dadosTotalProducoesNormais,
        };
      } else {
        return state;
      }

    case actions.DEM_FIN_ATUAL__SET_PRODUCOES_SOBREAVISO:
      if (action.payload) {
        const dadosProducoesSobreaviso =
          action.payload as ProducoesNormaisType[];
        const dadosTotalProducoesSobreaviso = dadosProducoesSobreaviso.reduce(
          (ant, prod) => {
            return {
              TurnoDiurno: {
                Valor: ant.TurnoDiurno.Valor + prod.TurnoDiurno.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoDiurno.HorasTrabalhadas +
                  prod.TurnoDiurno.HorasTrabalhadas,
              },
              TurnoNoturno: {
                Valor: ant.TurnoNoturno.Valor + prod.TurnoNoturno.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoNoturno.HorasTrabalhadas +
                  prod.TurnoNoturno.HorasTrabalhadas,
              },
              TurnoDiurnoFDS: {
                Valor:
                  ant.TurnoDiurnoFDS.Valor + prod.TurnoDiurnoFDS.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoDiurnoFDS.HorasTrabalhadas +
                  prod.TurnoDiurnoFDS.HorasTrabalhadas,
              },
              TurnoNoturnoFDS: {
                Valor:
                  ant.TurnoNoturnoFDS.Valor + prod.TurnoNoturnoFDS.ValorExtrato,
                HorasTrabalhadas:
                  ant.TurnoNoturnoFDS.HorasTrabalhadas +
                  prod.TurnoNoturnoFDS.HorasTrabalhadas,
              },
            };
          },
          {
            TurnoDiurno: { Valor: 0, HorasTrabalhadas: 0 },
            TurnoNoturno: { Valor: 0, HorasTrabalhadas: 0 },
            TurnoDiurnoFDS: { Valor: 0, HorasTrabalhadas: 0 },
            TurnoNoturnoFDS: { Valor: 0, HorasTrabalhadas: 0 },
          }
        );
        return {
          ...state,
          dadosProducoesSobreaviso,
          dadosTotalProducoesSobreaviso,
        };
      } else {
        return state;
      }

    case actions.DEM_FIN_ATUAL__SET_DETALHAMENTOS_EXTRA:
      if (action.payload) {
        const dadosDetalhamentosExtra =
          action.payload as DetalhamentosExtraType[];

        return {
          ...state,
          dadosDetalhamentosExtra,
        };
      }
      return state;

    case actions.DEM_FIN_ATUAL__SET_FILTROS:
      const {
        dadosExtratoSintetico,
        dadosDemonstrativo,
        dadosPlantoesNormais,
        dadosPlantoesNormaisResumo,
        dadosPlantoesSobreaviso,
        dadosPlantoesSobreavisoResumo,
        dadosProducoesNormais,
        dadosProducoesSobreaviso,
        dadosRelatorioProdutividade,
        dadosProcedimentos,
        dadosDetalhamentosExtra,
      } = initialState;
      return {
        ...state,
        filtros: action.payload,
        dadosExtratoSintetico,
        dadosDemonstrativo,
        dadosPlantoesNormais,
        dadosPlantoesNormaisResumo,
        dadosPlantoesSobreaviso,
        dadosPlantoesSobreavisoResumo,
        dadosProducoesNormais,
        dadosProducoesSobreaviso,
        dadosRelatorioProdutividade,
        dadosProcedimentos,
        dadosDetalhamentosExtra,
      };

    case actions.DEM_FIN_ATUAL__LIMPAR_FILTROS:
      return {
        ...state,
        filtros: initialState.filtros,
      };

    case actions.DEM_FIN_ATUAL__SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case "SESSION__LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default reducer;
